import { render, staticRenderFns } from "./KSjhTable.vue?vue&type=template&id=192c0f75&scoped=true"
import script from "./KSjhTable.vue?vue&type=script&lang=js"
export * from "./KSjhTable.vue?vue&type=script&lang=js"
import style0 from "./KSjhTable.vue?vue&type=style&index=0&id=192c0f75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192c0f75",
  null
  
)

export default component.exports